import { useQuery } from "@tanstack/react-query";

import { api } from "@/api/client";

/**
 * 시스템 헬스 훅 (2026-07-16 전수조사 시정 2건의 공용 소스):
 * - storage.ephemeral: SQLite 배포 = 재기동 시 데이터 초기화 → 상시 고지 배너
 * - ros_bridge.available: false 면 라이브 전용 컨트롤(E-STOP·수색스펙 발행)을
 *   사전 비활성 — '눌러보고 503' 이 아니라 '실기 전용' 을 먼저 표시
 *
 * /api/v1/system/health 는 루트 /health 의 별칭 (dev 프록시·nginx 가 /api 만
 * 중계하는 환경 호환). 조회 실패 시 undefined — 소비측은 '미상' 으로 처리하고
 * 컨트롤을 막지 않는다 (헬스 조회 실패가 지휘 기능을 잠그면 안 됨).
 */
export interface SystemHealth {
  status: string;
  service?: string;
  version?: string;
  environment?: string;
  ros_bridge?: { available: boolean; status: string };
  storage?: { ephemeral: boolean };
}

export function useSystemHealth() {
  return useQuery({
    queryKey: ["system-health"],
    queryFn: async () => (await api.get<SystemHealth>("/system/health")).data,
    // 15s (적대검증: 안전 조작 사전 게이트가 stale available=false 를 '확인'으로
    // 오래 유지하면 rosbridge 복구 후에도 E-STOP 이 잠김 — 잠금 해제 지연 상한 축소)
    refetchInterval: 15_000,
    staleTime: 10_000,
    retry: 1,
  });
}
